import { ZNumberInput } from "components/ZNumberInput";

type PriceEditorProps = {
    value: number | null;
    onValueChange: (value: number | null | undefined) => void;
};

export default ({ value, onValueChange }: PriceEditorProps) => {
    return (
        <ZNumberInput
            type="price"
            value={value}
            onChange={onValueChange}
            containerClassName="h-100"
        />
        // <input
        //     type="text"
        //     value={value || ''}
        //     onChange={({ target: { value }}) => onValueChange(value === '' ? null : value)}
        // />
    );
 }